import React from 'react';

import { connect } from 'react-redux';

import CTA from './CTA/CTA'

import datax from './libs/data';

import './CTAs.scss'

const CTAs = props => {
    console.log(props.currLblsMob);

    const retThisMob = props.currLblsMob !== undefined ? (
        datax[props.currLblsMob.toLowerCase()].map((ctax,i) => {
            return <CTA 
                key={i}
                classAdd={`${ctax.cap}-${i}`}
                title={ctax.title}                    
                description={ctax.description}
                text={ctax.text}
                url={ctax.url}/>                   
        })
    ) : null;

    return (
        <>
            <div className="CTAS CTAS--desktop">
                {(datax[props.currentLabel.toLowerCase()].map((ctax, i)=>{
                    return <CTA 
                        key={i}
                        classAdd={`${ctax.cap}-${i}`}
                        title={ctax.title}                    
                        description={ctax.description}
                        text={ctax.text}
                        url={ctax.url}/>
                }))}                  
            </div>
            <div className="CTAS CTAS--mob">
                 {retThisMob}
            </div>
        </>
    )
}

const mapStateToProps = state => {
    return {
        currentLabel: state.questionsReducer.currentLabel,
    }
}

export default connect(mapStateToProps, null)(CTAs);